export interface PayloadAction<T, A = string> {
	type: A
	payload?: T
}

export const createAction = <T, A = string>(type: A, payload?: T): PayloadAction<T> => ({
	type: type as string,
	payload
})
